
import {mapState} from 'vuex';

export default {
    data(){
        return {
            
        }
    },
    computed:mapState({
        flag : state => state.flag
    }),

}